import { OneColumn } from 'components/page';
import { usePermissionsContext } from 'context/PermissionsContext';
import { PermissoesGrid, PermissoesGridFilter } from 'pages/cadastro/permissoes/components';

export function PermissoesListComp() {
    const { hasPermission } = usePermissionsContext();

    return (
        <OneColumn title="Grupos de Permissões" createButton={hasPermission(['GRUPO_PERMISSAO_CADASTRAR'])}>
            <PermissoesGridFilter />

            <PermissoesGrid />
        </OneColumn>
    );
}
